// assets/cart-timer.js
console.log("%c[cart-timer] cargado", "color:#4CAF50;font-weight:bold;");

(function () {
  const COOKIE_NAME = "cart_timer_expires";
  const COUNTDOWN_MINUTES = 10;

  function setCookie(name, value, minutes) {
    const d = new Date();
    d.setTime(d.getTime() + minutes * 60 * 1000);
    document.cookie = `${name}=${encodeURIComponent(
      value
    )};expires=${d.toUTCString()};path=/`;
  }

  function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for (let c of ca) {
      c = c.trim();
      if (c.indexOf(nameEQ) === 0) {
        return decodeURIComponent(c.substring(nameEQ.length));
      }
    }
    return null;
  }

  function initCartTimerOnBar(timerBar) {

    // limpiar interval previo
    if (timerBar._cartTimerInterval) {
      clearInterval(timerBar._cartTimerInterval);
    }

    let expiresAt = parseInt(getCookie(COOKIE_NAME), 10);
    const now = Date.now();

    if (Number.isNaN(expiresAt) || expiresAt <= now) {
      expiresAt = now + COUNTDOWN_MINUTES * 60 * 1000;
      // cookie dura más que el countdown, solo controla la fecha límite
      setCookie(COOKIE_NAME, String(expiresAt), 24 * 60);
    }

    timerBar.hidden = false;
    console.log("%c[cart-timer] Timer ACTIVO", "color:#4CAF50;font-weight:bold;");

    function render() {
      const diff = Math.floor((expiresAt - Date.now()) / 1000);
      const remaining = diff > 0 ? diff : 0;

      const m = Math.floor(remaining / 60);
      const s = remaining % 60;

      const minEl = timerBar.querySelector("[data-cart-minutes]");
      const secEl = timerBar.querySelector("[data-cart-seconds]");

      if (minEl) minEl.textContent = m.toString().padStart(2, "0");
      if (secEl) secEl.textContent = s.toString().padStart(2, "0");


      if (remaining <= 0) {
        clearInterval(timerBar._cartTimerInterval);
        console.log("[cart-timer] Timer expirado");
      }
    }

    render();
    timerBar._cartTimerInterval = setInterval(render, 1000);
  }

  async function mountCartTimer(root) {
    const scope = root || document;
    const timerBar = scope.querySelector("#cart-timer-bar");

    console.log("[cart-timer] mountCartTimer, timerBar:", !!timerBar);

    if (!timerBar) return;

    const hasDiscountAttr = timerBar.getAttribute("data-has-discount");
    const hasDiscount = hasDiscountAttr === "true";

    console.log("[cart-timer] data-has-discount =", hasDiscountAttr);

    if (!hasDiscount) {
      timerBar.hidden = true;
      if (timerBar._cartTimerInterval) {
        clearInterval(timerBar._cartTimerInterval);
        timerBar._cartTimerInterval = null;
      }
      console.log("[cart-timer] No hay descuento → no mostrar timer");
      return;
    }

    initCartTimerOnBar(timerBar);
  }

  window.mountCartTimer = mountCartTimer;

  // Eventos del tema
  document.addEventListener("DOMContentLoaded", () => {
    console.log("[cart-timer] DOMContentLoaded");
    mountCartTimer(document);
  });

  ["cart:change", "cart:refresh", "variant:add"].forEach((evtName) => {
    document.addEventListener(evtName, () => {
      console.log(`[cart-timer] EVENT → ${evtName}`);
      const drawer = document.querySelector("cart-drawer");
      mountCartTimer(drawer || document);
    });
  });

  document.addEventListener("dialog:after-show", (event) => {
    if (event.target?.id === "cart-drawer") {
      console.log("[cart-timer] EVENT → dialog:after-show");
      mountCartTimer(event.target);
    }
  });
})();
